<template>
  <div class>
    <drawer :title="addEditTitle" :dialogShow="addEditShow" @handleChange="handleChangeDrawer">
      <div slot="body">
        <div class="pay-mains">
          <el-form ref="form" :model="form" class="demo-ruleForm" label-position="left">
            <div class="member-msg">
              <div class="member-border">
                <el-avatar class="img" shape="circle" size="small" v-if="list.headImgUrl" :src="list.headImgUrl"></el-avatar>
                <el-avatar shape="circle" size="small" v-else :src="headerImg"></el-avatar>
                
                <div class="rows member-box" v-if="list.memberId || list.id">
                  <p>{{ list.nickName }}</p>
                </div>
                <div class="rows member-box" v-else>
                  <p>门店顾客</p>
                </div>
              </div>
            </div>
            <p class="order-title-boxs"><span class="blueBlock"></span><i>退款详情</i></p>
            <div class="audit-boxs">
              <div class="totals-box">
                <el-row class="order-details">
                  <el-col :span="13" class="pl10">商品名称</el-col>
                  <el-col :span="3">实付(元)</el-col>
                  <el-col :span="3">总数量</el-col>
                  <el-col :span="5" class="center pr10">退款数量</el-col>
                </el-row>
                <div class="order-scoll">
                  <el-row v-for="(item,index) in rows" :key="index" class="ml20 mr20 ptb20 borderB">
                    <div class="align-item">
                      <div class="mr10" @click="onClick(item)">
                        <img src="../../assets/images/new/orderrefund_unchecked.png" alt="" v-if="item.num <= 0">
                        <img src="../../assets/images/new/order_orderrefund_select.png" alt="" v-else-if="item.show">
                        <img src="../../assets/images/new/order_orderrefund_unchecked.png" alt="" v-else>
                      </div>
                      <div class="w100b">
                        <el-col :span="13" class="pl10" :class="[item.itemNum == 0 ? 'color999':'']">{{item.itemName}}</el-col>
                        <el-col :span="3" class="color999">{{item.realPayAmount}}</el-col>
                        <el-col :span="3" class="color999">{{item.itemNum}}</el-col>
                        <el-col :span="5" class="nums center pr10">
                          <span class="del-img" @click="blurItem('del',  item)">
                            <img src="../../assets/images/new/del.png" alt="">
                          </span>
                          <el-input v-model="item.num" readonly="" size="mini" style="width: 40px;" :disabled="item.itemNum == 0?true:false"></el-input>
                          <span class="del-img" @click="blurItem('add',item)">
                            <img src="../../assets/images/new/add.png" alt="">
                          </span>
                        </el-col>
                        <el-col :span="4" class="pl10 mt20 color999">订单提成：</el-col>
                        <el-col :span="20" class="mt20 pr10">
                          <div :class="[item.itemNum == 0 ? 'color999':'']">{{item.staffNames}}</div>
                        </el-col>
                        <el-col :span="4" class="pl10 mt20 color999">社保补贴：</el-col>
                        <el-col :span="20" class="mt20 pr10">
                          <div :class="[item.itemNum == 0 ? 'color999':'']">{{item.staffSocialSubsidy}}</div>
                        </el-col>
                      </div>
                    </div>
                  </el-row>
				  <el-form-item label="退款类型：" prop="refundReasonType" class="plr24">
				      <el-radio-group v-model="form.refundReasonType">
				        <el-radio label="customerRefund">客户退款</el-radio>
				        <el-radio label="optFault">操作失误</el-radio>
				      </el-radio-group>
				  </el-form-item>
				  <el-form-item label="可退款金额" prop="refundReasonType" class="plr24" v-if="form.refundMethod=='custom'">
				       <span>{{ (avaibleAmount).toFixed(2) }}</span>
				  </el-form-item>
				  <el-form-item label="退款金额" prop="refundReasonType" class="plr24" v-if="form.refundMethod!='custom'">
				       <span>{{ (avaibleAmount).toFixed(2) }}</span>
				  </el-form-item>
				  <el-form-item label="退款金额：" prop="refundReasonType" class="plr24" v-if="form.refundMethod=='custom'">
				    <el-col :span="20" >
				     <el-input
				       class="input"
				       v-model="form.refundAmount"
				       placeholder="请输入退款金额"
				       maxlength="8"
					   @input="inputMatchMethod()" @focus="inputFocus()"
				     ></el-input>
				    </el-col>
				  </el-form-item>
				   <p class="order-title-boxs"><span class="blueBlock"></span><i>备注</i></p>
                  <div class="plr24 mb30">
                    <el-input type="textarea" v-model="form.remark" placeholder="请输入备注" maxlength="150" show-word-limit></el-input>
                  </div>
                  <div class="paperIndex-info">
                    <p class="tips-title infos">温馨提示</p>
                    <div class="hint" v-for="(item,index) in tips" :key="index">{{ item }}</div>
                  </div>
                </div>
              </div>
            </div>
          </el-form>
        </div>
        <div class="drawer-footer">
          <div class="btns pr24 pb10">
            <div class="flex-row">
              <p>
                退款数量：
                <span class="moneys">{{ totalNums }}</span>
              </p>
              <p>
                退款总金额：
                <span class="moneys">{{ (totalAmount).toFixed(2) }}</span>
              </p>
            </div>
            <el-button type="primary" class="small-btn" @click="save">确定申请</el-button>
          </div>
        </div>
      </div>
    </drawer>
    <el-dialog title="提示" :visible.sync="dialogVisible" width="400px" :close-on-click-modal="false">
      <div class="refundDialog">
        <el-form
          ref="form"
          label-position="right"
          :model="form"
          label-width="100px"
        >
          <el-form-item label="退款总金额：">
            ￥{{(totalAmount).toFixed(2)}}
          </el-form-item>
          <el-form-item label="本金退款：">
            ￥{{refundbaseAmount}}
          </el-form-item>
          <el-form-item label="赠金退款：">
            ￥{{refundGiveAmount}}
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="cancel">取 消</el-button>
        <el-button type="primary" @click="confirm">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import minxin from "../../assets/javascript/minxin.js";
import drawer from "../../components/common/drawer";
import member from "../components/member";
export default {
  mixins: [minxin],
  components: { drawer, member },
  data() {
    return {
      radio: 0,
      addEditTitle: "订单退款",
      addEditShow: false,
      totalAmount: 0,
      totalNums: 0,
      tips: [],
      form: {
        refundType: "order",
        orderId: "",
        refundAmount: "",
        refundDeductAmount: "",
        staffId: "",
        remark: "",
        refundItemList: [],
        refundReasonType: "",
		refundMethod:'',
      },
      staffIdList: [],
      staffNameList: [],
      rows: {},
      list: {},
      multipleSelection: [],
      headerImg: require("../../assets/images/headerImg.png"),
      dialogVisible: false,
      refundGiveAmount: 0,
      refundbaseAmount: 0,
      parmas: {},
	  orderType:'',
	  realPayAmount:0,
	  givePayAmount:0,
	  avaibleAmount:0,
	  oldAmount: '',
    };
  },
  created() {
    this.editInit();
  },
  methods: {
    back() {
      this.addEditShow = false;
    },
    memberChange(value) {
      if (value == "") {
        this.addEditShow = false;
        this.$emit("change", false);
      }
    },
    onClick (item) {
      if (item.itemNum <= 0) return
      item.show = !item.show;
      let num = Number(item.num)
      let realPrice = Number(item.realPrice)
      let itemNumEffective = Number(item.itemNumEffective)
      let realPayAmount = Number(item.realPayAmount)
      if (!item.show && this.totalNums > 0) {
        this.totalAmount -= num * realPrice;
        this.totalNums -= num;
		    this.avaibleAmount -= num * realPrice;
      } else {
        if (num == itemNumEffective) {
          this.totalAmount += realPayAmount
          this.totalNums += num;
          this.avaibleAmount += realPayAmount;
        } else {
          this.totalAmount += num * realPrice;
          this.totalNums += num;
          this.avaibleAmount += num * realPrice;
        }
      }
    },
    getTips() {
      this.$api.get(this.$url.companyRefund.getTips, {type: "refundOrder"}).then(res => {
          if (res) {
            this.tips = res;
          }
        });
    },
    editInit() {
      this.$on("set", function(org) {
        Object.assign(this.$data, this.$options.data());
        this.getTips();
        this.addEditShow = true;
        this.form.orderId = org.id;
		this.orderType=org.orderType;
		this.realPayAmount=org.realPayAmount;
		this.givePayAmount=org.givePayAmount;
        this.getdeduct();
        if (org.mobile) {
          this.getMenber(org);
        }
      });
    },
    getdeduct () {
      // listItemWithStaffDeduct
      this.$api.get(this.$url.orderInfo.listItemWithStaffDeduct, {id: this.form.orderId}).then(res => {
        if (res) {
		  this.avaibleAmount=0;
		  var dataList=res.orderItemDeductVOList;
		  this.form.refundMethod=res.refundMethod;
          dataList.map(it => {
            this.$set(it, "itemAmount", "");
            this.$set(it, "show", false);
            this.$set(it, "num", it.itemNumEffective);
            this.$set(it, "single", Number(it.realPayAmount) / Number(it.itemNum));
            let arr = [],arr1 = [];
            it.orderStaffDeductVOList.map(item => {
              arr.push(item.staffName + '￥' + item.deductAmount)
              arr1.push(item.staffName + '￥' + item.socialSubsidyAmount)
            })
            it.staffNames = arr.join("、");
            it.staffSocialSubsidy = arr1.join("、");
          })
          this.rows = dataList;
        }
      })
    },
    getMenber (org) {
      this.$api.get(this.$url.member.search, {
        keyword: org.mobile,
        needIntegralFlag: false
      }).then(res => {
        if (res) {
          if (res.memberList.length) {
            this.list = res.memberList[0];
          } else {
            org.nickName = org.customerName;
            this.list = org;
          }
        }
      })
    },  
    handleChangeDrawer() {
      this.$refs["form"].clearValidate();
      this.addEditShow = false;
      this.$emit("change", false);
    },
    blurItem(type,item) {
      if (type == 'del') {
        if (item.num > 1) {
          item.num--;
          if (item.show) {
            this.totalAmount -= item.realPrice;
			this.avaibleAmount-=item.realPrice;
            this.totalNums--;
          }
        };
      } else {
        if (item.num >= item.itemNum) return
        item.num++;
        if (item.show) {
          this.totalAmount += item.realPrice;
		  this.avaibleAmount+=item.realPrice;
          this.totalNums++;
        }
      }
		},
    save() {
      let array = [];
	  if(this.rows==undefined || this.rows.length==undefined|| this.rows.length==0){
		  this.$message.warning("退款数据获取失败！");
		  return false;
	  }
      this.rows.map(item => {
        if (item.show) {
          array.push(JSON.parse(JSON.stringify(item)))
        }
      })
      console.log("值：",array);
      if (array.length <= 0) {
        this.$message.warning("请选择至少一条消费明细！");
        return false;
      }
      if (!this.form.refundReasonType) {
        this.$message.warning("请选择退款类型");
        return false;
      }
      if (!this.form.remark) {
        this.$message.warning("请输入备注！");
        return false;
      }
      let arr = [];
      let a = 0,b = 0;
      for (let i in array) {
        if (array[i].num == array[i].itemNum) {
          a += Number(array[i].basePayAmountSum);
          b += Number(array[i].givePayAmountSum);
        } else {
          a += (Number(array[i].basePayAmount) * Number(array[i].num));
          b += (Number(array[i].givePayAmount) * Number(array[i].num));
        }
        this.refundbaseAmount = a.toFixed(2);
        this.refundGiveAmount = b.toFixed(2);
        arr.push(array[i]);
        this.$set(arr[i], "itemId", array[i].itemId);
        this.$set(arr[i], "orderItemId", array[i].id);
        this.$set(arr[i], "itemType", array[i].itemType);
        this.$set(arr[i], "itemNum", array[i].num);
      }
	  var refundAmount=0;
	  if(this.form.refundMethod!='custom')
	  {
		  refundAmount=this.totalAmount;
	  }else
	  {
		  if (!this.form.refundAmount) {
		    this.$message.warning("请输入退款金额！");
		    return false;
		  }
		  refundAmount=Number(this.form.refundAmount);
		  if (refundAmount>this.avaibleAmount) {
		    this.$message.warning("退款金额不能大于"+this.avaibleAmount+"元，请重新输入！");
		    return false;
		  }
	  }
      let obj = {
        remark: this.form.remark,
        orderId: this.form.orderId,
        refundItemList: arr,
        refundReasonType: this.form.refundReasonType,
		refundAmount:refundAmount
      };
      this.parmas = obj;
	  //卡项去请求接口
		 // if(array[0].itemType==='card'){
		 //  this.$api.post(this.$url.companyRefund.calculateRefundAmount, this.parmas).then(res => {
			// if (res) {
			//   this.refundbaseAmount = res.refundBaseAmount;
			//   this.refundGiveAmount = res.refundGiveAmount;
			//   this.totalAmount = res.refundAmount;
			// }
		 //  })
		 // }
	 if(this.form.refundMethod=='custom' && refundAmount!=this.avaibleAmount)
	 {
		 var rate=(this.givePayAmount/this.realPayAmount).toFixed(4);
		 this.refundGiveAmount =(Number(this.form.refundAmount)* rate).toFixed(2);
		 this.refundbaseAmount= (Number(this.form.refundAmount) - this.refundGiveAmount).toFixed(2);
	 }
	this.dialogVisible = true;
    },
    confirm () {
      this.$api.post(this.$url.companyRefund.applyOrder, this.parmas).then(res => {
        if (res) {
          this.cancel();
          this.addEditShow = false;
          this.$message.success("操作成功");
          this.$emit("change", true);
        }
      })
    },
    cancel () {
      this.dialogVisible = false;
      this.refundbaseAmount = 0;
      this.refundGiveAmount = 0;
    },
	inputMatchMethod() {
		if (this.form.refundAmount == '') {
			return;
		}
		var reg = /^(\d{0,8})(\.(\d{0,2}))?$/g
		if (!reg.test(this.form.refundAmount)) {
			this.form.refundAmount = this.oldAmount;
		} else {
			this.oldAmount = this.form.refundAmount;
		}
		this.totalAmount=Number(this.form.refundAmount);
	},
	inputFocus(e) {
		this.oldAmount =this.form.refundAmount;
	}
  }
};
</script>
<style scoped lang="less">
@import "../../assets/css/edit.less";

.btns {
  display: flex;
  align-items: center;
  p {
    margin-right: 30px;
  }
}
.member-msg {
  padding: 16px 16px 0;
  .member-border {
    width: 100%;
    background-size: 100% 100%;
    color: white;
    display: flex;
    align-items: center;
    border-radius: 10px;
    padding: 12px 15px;
    background: #3388ff;
    box-sizing: border-box;
    .member-box {
      margin-left: 10px;
      .mobile {
        line-height: 1.6;
        margin-right: 46px;
      }
    }
  }
}
.active {
  border-left: 3px solid #3388FF;
  background: #F3F8FE;
}
.nums {
  display: flex;
  justify-content: center;
  .del-img {
    width: 28px;
    height: 28px;
    cursor: pointer;
    img {
      width: 100%;
      height: 100%;
    }
  }
  /deep/ .el-input__inner {
    border-radius: inherit;
    text-align: center;
    padding: 0;
    border-left: none;
    border-right: none;
  }
}
.order-scoll {
  max-height: calc(100vh - 360px);
  overflow: auto;
}
.tips {
  position: absolute;
  bottom: 80px;
  padding: 10px 20px;
  .tips-title {
    margin-bottom: 10px;
  }
  .infos {
    color: #111;
  }
  .hint {
    font-size: 16px;
    color: #666;
    line-height: 26px;
  }
}

.paperIndex-info {
  width: calc(100% - 90px);
  margin: 0 24px;
  font-size: 16px;
  background: #FBFBFC;
  border: 1px solid #E5E5E5;
  border-radius: 4px;
  color: #666;
  padding: 20px;
}
.refundDialog {
  font-size: 18px;
  color: #333;
}
</style>